// @flow

export * from './ellastvmaxauTheme'
export { default as ellastvmaxauBrandConfig } from './brand_config.json'
